import { tryCatchHelper } from '../../../../helpers';
import {
  allPlanEvaluacionAction,
  onePlanEvaluacionAction,
} from '../plan_evaluacion/PlanEvaluacionAction';
import { ACTIVO_PTEM_EVALUACIONES } from './PtemEvaluacionesReducer';
import {
  deletePtemEvaluacionesService,
  onePtemEvaluacionesService,
  savePtemEvaluacionesService,
} from './PtemEvaluacionesService';

export const savePtemEvaluacionesAction = async (
  { dispatch, notify },
  idPlanEvaluacion,
  id,
  data,
  paramsPlanEvaluacion,
) => {
  try {
    const res = await savePtemEvaluacionesService(id, data);
    notify(res.data.message);
    await onePlanEvaluacionAction(dispatch, idPlanEvaluacion);
    await allPlanEvaluacionAction(dispatch, paramsPlanEvaluacion);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPtemEvaluacionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PTEM_EVALUACIONES, payload: data });
};

export const onePtemEvaluacionesAction = async (dispatch, id) => {
  const res = await onePtemEvaluacionesService(id);
  if (res.status === 200) {
    await setActivoPtemEvaluacionesAction(dispatch, res.data);
    return true;
  }
  return false;
};

export const deletePtemEvaluacionesAction = async (
  { dispatch, notify },
  idPlanEvaluacion,
  id,
) => {
  try {
    const res = await deletePtemEvaluacionesService(id);
    notify(res.data.message);
    await setActivoPtemEvaluacionesAction(dispatch, null);
    await onePlanEvaluacionAction(dispatch, idPlanEvaluacion);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
